import { createReducer, on } from '@ngrx/store';
import {
  AUTH_FIND_SUCCESS,
  AUTH_FAILED,
  AUTH_UPDATE_LOADING,
  AUTH_UPDATE_FORM,
  AUTH_RESET_STATE,
  AUTH_SING_UP_FAILURE,
  AUTH_SING_UP_SUCCESS,
  AUTH_RESET_REGISTRATION,
  USER_UPDATE_FORM,
  USER_CLEAR_STATE,
} from '../actions';
import { Authentication, AuthenticationForm, User } from '@core/models';

export interface AuthState {
  auth: Authentication | null;
  error: string | null;
  loading: boolean;
  authForm: AuthenticationForm | null;
  registered: boolean;
  userForm: User | null;
}

const initialState: AuthState = {
  auth: null,
  error: null,
  loading: false,
  authForm: null,
  registered: false,
  userForm: null
};

export const authReducer = createReducer(
  initialState,
  on(AUTH_FIND_SUCCESS, (state, { auth }) => ({ ...state, auth: { ...state.auth, ...auth } })),
  on(AUTH_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(AUTH_UPDATE_FORM, (state, { authForm }) => ({ ...state, authForm })),
  on(AUTH_FAILED, (state, { error }) => ({ ...state, error })),
  on(AUTH_RESET_STATE, () => ({ ...initialState })),
  on(AUTH_SING_UP_SUCCESS, (state, { registered }) => ({...state,registered,error: null,})),
  on(AUTH_SING_UP_FAILURE, (state, { error }) => ({...state, registered: false, error,})),
  on(AUTH_RESET_REGISTRATION, (state) => ({ ...state,  registered: false })),
  on(USER_UPDATE_FORM, (state, { userForm }) => ({ ...state, userForm })),
  on(USER_CLEAR_STATE, () => initialState),
);
